@if (isVisible()) {
<div
  class="pwa-install-banner fixed bottom-0 left-0 right-0 z-9999 bg-white shadow-lg border-t border-surface-200 animate-slide-up"
>
  <div class="flex flex-col gap-3 p-4">
    <div class="flex items-center gap-3">
      <img
        src="icons/icon-72x72.png"
        alt="App Icon"
        class="w-12 h-12 rounded-lg flex-shrink-0"
      />
      <div class="flex-1">
        <h3 class="text-surface-900 font-semibold text-base">
          {{ 'shared.pwa.install.title' | translate }}
        </h3>
        <p class="text-surface-600 text-sm">
          @if (isIOS) { {{ 'shared.pwa.install.description-ios' | translate }} }
          @else { {{ 'shared.pwa.install.description' | translate }} }
        </p>
      </div>
    </div>
    <div class="flex flex-row gap-2 w-full">
      <button
        (click)="dismiss()"
        class="flex-1 px-3 py-2 text-surface-700 text-sm font-medium rounded-lg hover:bg-surface-100 transition-colors"
      >
        {{ 'shared.pwa.install.dismiss' | translate }}
      </button>
      <button
        (click)="install()"
        class="flex-1 px-4 py-2 bg-primary-500 text-surface-700 text-sm font-semibold rounded-lg hover:transition-colors"
      >
        @if (isIOS) { {{ 'shared.pwa.install.install-ios' | translate }} } @else
        { {{ 'shared.pwa.install.install' | translate }} }
      </button>
    </div>
  </div>
</div>
} @if (isIosBrowserVisible()) {
<div
  class="ios-browser-banner fixed bottom-0 left-0 right-0 z-9999 bg-blue-600 shadow-lg animate-slide-up"
>
  <div class="flex flex-col gap-4 p-4 text-white">
    <div class="flex items-start gap-3">
      <div class="flex-1">
        <h3 class="font-semibold text-base mb-1">
          {{ 'shared.pwa.install.safari-title' | translate }}
        </h3>
        <p class="text-sm opacity-90">
          {{ 'shared.pwa.install.safari-description' | translate }}
        </p>
        <p class="text-xs opacity-80 mt-2">
          {{ 'shared.pwa.install.safari-step1' | translate }}<br />
          {{ 'shared.pwa.install.safari-step2' | translate }}<br />
          {{ 'shared.pwa.install.safari-step3' | translate }}<br />
          {{ 'shared.pwa.install.safari-step4' | translate }}<br />
        </p>
      </div>
    </div>
    <div class="flex flex-row gap-2 w-full">
      <button
        (click)="dismissIosBrowserBanner()"
        class="flex-1 px-3 py-2 text-blue-700 bg-white text-sm font-medium rounded-lg hover:bg-blue-50 transition-colors"
      >
        {{ 'shared.pwa.install.dismiss' | translate }}
      </button>
      <button
        (click)="openInSafari()"
        class="flex-1 px-4 py-2 bg-white text-blue-700 text-sm font-semibold rounded-lg hover:bg-blue-50 transition-colors"
      >
        {{ 'shared.pwa.install.open-safari' | translate }}
      </button>
    </div>
  </div>
</div>
} @if (isEdgeVisible()) {
<div
  class="edge-browser-banner fixed bottom-0 left-0 right-0 z-9999 bg-gradient-to-r from-orange-400 to-orange-500 shadow-lg animate-slide-up"
>
  <div class="flex flex-col gap-4 p-4 text-white">
    <div class="flex items-start gap-3">
      <div class="flex-1">
        <h3 class="font-semibold text-base mb-1">
          🚀 Get Better PWA Experience
        </h3>
        <p class="text-sm opacity-90">
          Microsoft Edge has limitations for PWA installation on Android. Google
          Chrome provides a better experience with full WebAPK support and
          offline capabilities.
        </p>
        <p class="text-xs opacity-75 mt-2">
          We recommend using Chrome for the best features.
        </p>
      </div>
    </div>
    <div class="flex flex-row gap-2 w-full">
      <button
        (click)="dismissEdgeBanner()"
        class="flex-1 px-3 py-2 text-orange-600 bg-white text-sm font-medium rounded-lg hover:bg-orange-50 transition-colors"
      >
        Not Now
      </button>
      <button
        (click)="openInChrome()"
        class="flex-1 px-4 py-2 bg-white text-orange-600 text-sm font-semibold rounded-lg hover:bg-blue-50 transition-colors"
      >
        Open in Chrome
      </button>
    </div>
  </div>
</div>
}

<app-ios-install-instructions
  [isOpen]="showIosInstructions"
  (onCloseDialog)="closeInstructions()"
></app-ios-install-instructions>
